<script lang="ts" setup>
import { GridItemsProps } from "./GridItems.props"

defineProps<GridItemsProps>()
</script>

<template>
  <div class="who-we-are space-y-10 bg-tiffany-10 pb-10 pt-6">
    <p
      v-if="!!title"
      class="dolphin-bold md:elephant-bold text-center text-green-main"
    >
      {{ title }}
    </p>
    <div
      class="
        who-we-are__content
        flex flex-col
        items-center
        gap-x-4 gap-y-10
        px-[13px]
        md:flex-row
        md:items-start
        md:justify-between
        md:gap-y-0
        md:px-[71px]
        lg:justify-center
        lg:gap-x-[107px]
        lg:px-[228px]
      "
    >
      <BannerWhoWeAreUtilsCard
        v-for="(card, i) in cards"
        :key="`card-${i}`"
        class="md:w-[20.875rem]"
        :="card"
      />
    </div>
  </div>
</template>
